module.exports = __webpack_public_path__ + "static/media/6get.6d1b7410.svg";